// App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthProvider from './providers/authProviders';
import CountryProvider from './context/CountryContext';
import { ThemeProvider } from './providers/ThemeProvider';
import routes from './routes/routes';
import ModalProvider from './components/modalProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './scss/style.scss';
import { SelectedItemProvider } from './components/menu/SelectedItemContext';
import RequireAdmin from './components/RequireAdmin';
import RequireHolding from './components/RequireHolding/requireHolding';
import RequireControlTower from './components/RequireControlTower';
import ErrorBoundary from './components/errorBoundary/ErrorBoundary';

function App() {
  const renderRouteElement = (route) => {
    const element = <route.element routes={route.children} />;
    if (route.adminOnly) return <RequireAdmin>{element}</RequireAdmin>;
    if (route.holdingOnly) return <RequireHolding>{element}</RequireHolding>;
    if (route.controlTowerOnly) return <RequireControlTower>{element}</RequireControlTower>;
    return element;
  };

  return (
    <BrowserRouter>
      <ThemeProvider>
        <ModalProvider />
        <ErrorBoundary>
          <SelectedItemProvider>
            <Routes>
              {routes.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <AuthProvider>
                        <CountryProvider>{renderRouteElement(route)}</CountryProvider>
                      </AuthProvider>
                    }
                  />
                );
              })}
            </Routes>
          </SelectedItemProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
